module.exports = __webpack_public_path__ + "img/credit-card-solid updated.1768de39.svg";